import React from "react";
import Settings from "components/Panel/Admin/Settings";
const SettingsContainer = () => {
  return <Settings />;
};

export default SettingsContainer;
